const profile = {
    name: 'الاسم',
    avatar: 'الصورة الرمزية',
    givenName: 'الاسم الأول',
    familyName: 'اسم العائلة',
    middleName: 'الاسم الأوسط',
    fullName: 'الاسم الكامل',
    nickname: 'الاسم المستعار',
    preferredUsername: 'اسم المستخدم المفضل',
    profile: 'الملف الشخصي',
    website: 'الموقع الإلكتروني',
    gender: 'الجنس',
    birthdate: 'تاريخ الميلاد',
    zoneinfo: 'معلومات المنطقة الزمنية',
    locale: 'اللغة والمنطقة',
    address: {
        formatted: 'العنوان',
        streetAddress: 'عنوان الشارع',
        locality: 'المدينة',
        region: 'الولاية/المقاطعة',
        postalCode: 'الرمز البريدي',
        country: 'الدولة',
    },
};
export default Object.freeze(profile);
